module.exports = __webpack_public_path__ + "static/img/img_3.ee732f30.jpg";